import type { ClassValue } from "clsx";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Capitalizes the first letter of each whitespace-separated word.
 * Unicode-aware: handles diacritics and non-ASCII characters correctly.
 */
export function toTitleCase(str: string): string {
  if (!str) return str;
  return str.replace(/\S+/gu, (word) =>
    word.length > 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word
  );
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

/** "10:15 AM" — the time shown under a chat bubble (matches v3). */
export function formatMessageTime(iso: string): string {
  return new Date(iso).toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });
}

/**
 * Human title for a JD S3 key, e.g.
 * "JobDescription/<id>/20260824T030515Z_<id>_Art Director.txt" → "Art Director".
 */
export function jobTitleFromJdPath(jdPath?: string | null): string {
  if (!jdPath) return "Scouted Candidates";
  const base = jdPath.split("/").pop() ?? "";
  const match = base.match(/^\d{8}T\d{6}Z_[a-f0-9-]{36}_(.+)$/);
  const name = (match?.[1] ?? base).replace(/\.[^.]+$/, "").trim();
  return name || "Scouted Candidates";
}
